import PropTypes from 'prop-types'
import { Text as NuiText } from '@theneatcompany/nui'
import type { TextProps as NuiTextProps } from '@theneatcompany/nui'

import { getMessage } from '@/utils/messages'
import type { MessageId, MessageProps } from '@/translations/messages'

interface TextProps extends NuiTextProps {
  messageProps?: MessageProps
  messageId?: MessageId
}

// @TODO Will need to use forwardRef if the nui Text component is updated to use forwardRef
const Text = ({ messageProps = {}, messageId = messageProps.id, children, ...rest }: TextProps) => (
  <NuiText {...rest}>{messageId ? getMessage(messageId, messageProps.values) : children}</NuiText>
)

Text.propTypes = {
  messageProps: PropTypes.shape({ id: PropTypes.string, values: PropTypes.shape({}) }),
  messageId: PropTypes.string,
  children: PropTypes.node,
}

export default Text
